import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { FragmentsModule } from 'src/app/fragments/fragments.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { LoginTemplateComponent } from './login-template.component';
import { RenewPasswordComponent } from './renew-password/renew-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginSelectionProfilComponent } from './login-selection-profil/login-selection-profil.component';
import { SelectDocteurComponent } from './select-docteur/select-docteur.component';
import { AuthGuard } from 'src/app/services/auth/auth.guard';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RecaptchaModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { OAuthModule } from 'angular-oauth2-oidc';
import { StopPageComponent } from './stop-page/stop-page.component';

const routes: Routes = [
  {
    path: '',
    component: LoginTemplateComponent,
    children: [
      {
        path: '',
        component: LoginComponent
      },
      {
        path: 'select-profil/:id',
        component: LoginSelectionProfilComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'select-docteur',
        component: SelectDocteurComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent
      },
      {
        path: 'renew-password/:email',
        component: RenewPasswordComponent
      },
      {
        path: 'stop-page/:type',
        component: StopPageComponent
      },
    ],
  },
];
@NgModule({
  declarations: [
    LoginComponent,
    LoginTemplateComponent,
    ForgotPasswordComponent,
    RenewPasswordComponent,
    LoginSelectionProfilComponent,
    SelectDocteurComponent,
    StopPageComponent
  ],
  imports: [
    CommonModule,
    FragmentsModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    MatTooltipModule,
    RecaptchaModule,
    OAuthModule.forRoot()
  ],
  providers: [
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'fr',
    },
  ]
})
export class LoginModule { }
